<template>
    <div class="contenedor">
        <span v-if="$router.history.current.path != '/'">
            <Player></Player>
        </span>
        <router-view></router-view>
    </div>
</template>

<script>

import Bienvenido from './components/Bienvenido';
import Player from './components/Player';

import { mapActions } from 'vuex';

import router from './main';

console.log("ROUTER => " + router);

const INTERVAL = 120000

export default {
    name: 'App',
    components: {
        Bienvenido,
        Player,
    },
    created() {
        var self = this;
        self.$store.dispatch('getCancionPedida');
        self.$store.dispatch('getArtistas');
        var artistas = setInterval(() => {
            self.$store.dispatch('getArtistas');
        }, INTERVAL);
    },
    methods: mapActions(['getArtistas', 'getCancionPedida']),
};

</script>

<style scoped>
.contenedor {
    margin: auto;
    margin-top: 12.8rem;
    font-family: sans-serif;
    color: #fff;
}
</style>